/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const dpPaymentForm = {
  dpPaymentForm: {
    redirect:
      'Em breve, você será redirecionado para a página de terceiros para registro do cartão',
    callback: 'Esperar... Obtenha detalhes de pagamento...',
    cancelledOrFailed: 'Erro ou cancelamento de registro do cartão',
    error: {
      redirect: 'Não é possível iniciar a operação. Por favor, tente novamente',
      paymentFetch: 'Os detalhes de pagamento não podem ser obtidos. Por favor, tente novamente.',
      unknown:
        'Ocorreu um erro desconhecido ao receber o pagamento. Entre em contato com o suporte',
    },
  },
};
